export const EmailRound = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <circle cx='12' cy='12' r='12' fill='#1A1519' fillOpacity='0.1'></circle>
        <path
          stroke='#1A1519'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M7 9.5l4.082 2.858c.331.231.496.347.676.392.159.04.325.04.484 0 .18-.045.345-.16.675-.392L17 9.5M9.4 16h5.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 00.655-.655c.164-.32.164-.74.164-1.581v-3.2c0-.84 0-1.26-.163-1.581a1.5 1.5 0 00-.656-.656C15.861 8 15.441 8 14.6 8H9.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 00-.656.656C7 9.139 7 9.559 7 10.4v3.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 00.656.655c.32.164.74.164 1.581.164z'
        ></path>
      </svg>
    </span>
  );
};
